import { twMerge } from "tailwind-merge";
import { Icon } from "@sellar-io/components";
import { IconType } from "@sellar-io/components";
import { ReactNode } from "react";

export const Toast = ({
  children,
  icon,
  className,
}: {
  children: ReactNode;
  icon?: IconType;
  className?: string;
}) => {
  return (
    <div
      className={twMerge(
        "mb-4 grid grid-cols-12 items-center rounded-lg bg-black p-4 text-center text-white shadow-lg",
        className,
        className?.includes("max-w-") ? "" : "max-w-100",
      )}
    >
      {icon && (
        <div className={"col-span-1 md:flex md:items-center md:justify-center"}>
          <Icon icon={icon} />
        </div>
      )}
      <div className={"col-span-11"}>{children}</div>
    </div>
  );
};
